import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const WITHHOLDING_TAX_SCHEMA = Object.freeze({
    NAME: 'Withholding',
    RATE: 0,
    ENABLED: false,
  }),
  RECORD = generateSchema(WITHHOLDING_TAX_SCHEMA),
  KEYS: any = generateKeys(WITHHOLDING_TAX_SCHEMA);

export class WithholdingTax extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get enabled(): boolean {
    return this.get(KEYS.ENABLED);
  }

  get rate(): number {
    return this.get(KEYS.RATE);
  }
}
